import { useMediaQuery } from '@mui/material';

export const useResponsive = () => {
  const isDesktop = useMediaQuery('(min-width: 1360px)');
  const isTablette = useMediaQuery('(min-width: 768px)');
  const isMobile = useMediaQuery('(max-width: 500px)');
  return { isDesktop, isTablette, isMobile };
};
